import { useState } from 'react';

/**
 * Custom hook to manage map state
 * @param {Object} initialCenter - Initial map center coordinates
 * @param {number} initialZoom - Initial map zoom level
 * @returns {Object} Map state and functions to update it
 */
export const useMapState = (
  initialCenter = { lat: 35.108732828085046, lng: -81.2255823864745 },
  initialZoom = 4.59
) => {
  const [mapCenter, setMapCenter] = useState(initialCenter);
  const [mapZoom, setMapZoom] = useState(initialZoom);
  
  /**
   * Updates map for a specific location
   * @param {Object} coordinates - Location coordinates
   */
  const updateMapForLocation = (coordinates) => {
    setMapCenter(coordinates);
    setMapZoom(17.6);
  };
  
  /**
   * Resets map to initial state
   */
  const resetMap = () => {
    setMapCenter(initialCenter);
    setMapZoom(initialZoom);
  };
  
  return {
    mapCenter,
    mapZoom,
    setMapCenter,
    setMapZoom,
    updateMapForLocation,
    resetMap
  };
};

export default useMapState; 
